import React, { Fragment } from 'react';
import { TableBodyItem } from '../../Table.styles';
import { formatPrice } from '../../../../utils/util';
import { format } from 'date-fns';
import { useLocation, useParams } from 'react-router-dom';
import { CHAT, CHATTER_MESSAGES, MESSAGES } from '../../../App/routes';
import { Link } from '../ChatterInfluencerItem/ChatterInfluencerItem.styles';

const MESSAGE_TYPE_MAPPER = {
  PHOTO: 'User purchased photo',
  VIDEO: 'User purchased video',
  BUNDLE: 'User purchased bundle',
  NON_SPENDING_COUNTRY_TIP: 'User tipped',
  SUBSCRIPTION: 'User purchased monthly subscription',
  LIFETIME_SUBSCRIPTION: 'User purchased VIP',
  GIFT: 'User purchased gift',
  CUSTOM_VIDEO: 'User purchased custom video',
  OTHER: 'Unlock has been made',
};

const NotificationItem = ({ name, cost, type, createdAt, chatId }) => {
  return (
    <Fragment>
      <TableBodyItem>
        <TableBodyItemLinkWrapper chatId={chatId}>
          <p>{name}</p>
        </TableBodyItemLinkWrapper>
      </TableBodyItem>
      <TableBodyItem>
        <TableBodyItemLinkWrapper chatId={chatId}>
          <p>{MESSAGE_TYPE_MAPPER[type]}</p>
        </TableBodyItemLinkWrapper>
      </TableBodyItem>
      <TableBodyItem>
        <TableBodyItemLinkWrapper chatId={chatId}>
          <p>{format(createdAt, 'd.MM.yyyy HH:mm')}</p>
        </TableBodyItemLinkWrapper>
      </TableBodyItem>
      {(cost !== null && cost !== undefined) && (
        <TableBodyItem>
          <TableBodyItemLinkWrapper chatId={chatId}>
            <p>${formatPrice(cost)}</p>
          </TableBodyItemLinkWrapper>
        </TableBodyItem>
      )}
    </Fragment>
  );
};

const TableBodyItemLinkWrapper = ({ chatId, children }) => {
  const location = useLocation();
  const { influencerId } = useParams();
  const link = influencerId
    ? `/${CHATTER_MESSAGES.replace(':influencerId', influencerId)}/${CHAT.replace(':chatId', chatId)}`
    : `/${MESSAGES}/${CHAT.replace(':chatId', chatId)}`;

  return (
    <Link to={link} state={{ from: location }}>
      {children}
    </Link>
  );
};

export default NotificationItem;
